import React, { useEffect, useContext, useState } from "react";
import Context from '../context/context';
import helpers from '../_helpers/helpersFunction'
import Lang from '../lang/translations';

export default function FormSelectAges(props) {

  const [selectedAge, setSelectedAge] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const context = useContext(Context);

  useEffect(() => { 
    // Carica l'età preferita corrente dell'utente se disponibile
    if (context.user && context.user.preferred_age) {
      setSelectedAge(context.user.preferred_age);
    }
  }, [context.user]);

  const ageOptions = [
    { value: "18-24", label: "18-24" },
    { value: "25-34", label: "25-34" },
    { value: "35-44", label: "35-44" },
    { value: "45-54", label: "45-54" },
    { value: "55-99", label: "60+" }
  ];

  async function updateUserSearchAge(preferred_age) {
    var token = localStorage.getItem('token')
    var trackerId = localStorage.getItem('trackerId')

    return await fetch(process.env.REACT_APP_APIADDRESS+"/users/"+trackerId, {
      method: 'put',
      headers: {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+ token
      },
      body: JSON.stringify({preferred_age: preferred_age })
    })
    .then(response => response.json()) 
    .then(res => {
      if(res.result){
        return res.user
      }
    })
  }

  const handleAgeChange = async (event) => {
    const selectedValue = event.target.value;
    setSelectedAge(selectedValue);
    setIsLoading(true);

    try {
      const updatedUser = await updateUserSearchAge(selectedValue);
      if (updatedUser) {
        const updatedUserInfo = {
          ...context.user_info,
          preferred_age: selectedValue
        };
        
        context.setUser_info(updatedUserInfo);

      }
    } catch (error) {
      console.error('Errore nell\'aggiornamento dell\'età preferita:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="form-select-ages">
      <label htmlFor="age-select">
        { 'Età preferita per la ricerca:'}
      </label>
      <select 
        id="age-select"
        value={selectedAge}
        onChange={handleAgeChange}
        disabled={isLoading}
        className={`age-select ${isLoading ? 'loading' : ''}`}
      >
        <option value="">
          { context.user_info && context.user_info.preferred_age ? context.user_info.preferred_age : 'Seleziona età' }
        </option>
        {ageOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {isLoading && (
        <span className="loading-indicator">
          { 'Aggiornamento...'}
        </span>
      )}
    </div>
  );
}